<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Stagione', route: '/backoffice/stagione' }]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formStagione" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onSubmit()">
        <div class="ac-section-head">
            <h2>Dati stagione</h2>
        </div>

        <div class="fld">
            <label>* Titolo</label>
            <input type="text" pInputText class="w-full" placeholder="Titolo" formControlName="titolo" required />
            <small class="text-red-600 block mt-2 font-medium" *ngIf="formStagione.get('titolo')?.hasError('required') && (formStagione.get('titolo')?.dirty || formStagione.get('titolo')?.touched)">Il titolo è obbligatorio.</small>
        </div>

        <div class="fld">
            <label>Descrizione</label>
            <p-editor [style]="{ height: '150px' }" formControlName="descrizione" />
        </div>

        <div class="ac-section-head mt-2">
            <h2>Pulsanti</h2>
        </div>

        <div class="flex lg:flex-row flex-col gap-4">
            <div class="fld flex-1">
                <label>Testo pulsante</label>
                <input type="text" pInputText class="w-full" placeholder="Testo" formControlName="button" />
            </div>
            <div class="fld flex-1">
                <label>Link pulsante</label>
                <input type="text" pInputText class="w-full" placeholder="Link" formControlName="link" />
            </div>
        </div>
        <div class="flex lg:flex-row flex-col gap-4">
            <div class="fld flex-1">
                <label>Testo pulsante</label>
                <input type="text" pInputText class="w-full" placeholder="Testo" formControlName="button_2" />
            </div>
            <div class="fld flex-1">
                <label>Link pulsante</label>
                <input type="text" pInputText class="w-full" placeholder="Link" formControlName="link_2" />
            </div>
        </div>
        <div class="flex lg:flex-row flex-col gap-4">
            <div class="fld flex-1">
                <label>Testo pulsante</label>
                <input type="text" pInputText class="w-full" placeholder="Testo" formControlName="button_3" />
            </div>
            <div class="fld flex-1">
                <label>Link pulsante</label>
                <input type="text" pInputText class="w-full" placeholder="Link" formControlName="link_3" />
            </div>
        </div>
        <div class="flex lg:flex-row flex-col gap-4">
            <div class="fld flex-1">
                <label>Testo pulsante</label>
                <input type="text" pInputText class="w-full" placeholder="Testo" formControlName="button_4" />
            </div>
            <div class="fld flex-1">
                <label>Link pulsante</label>
                <input type="text" pInputText class="w-full" placeholder="Link" formControlName="link_4" />
            </div>
        </div>

        <div class="ac-section-head mt-2">
            <h2>Immagini</h2>
        </div>

        <div class="flex lg:flex-row flex-col gap-4">
            <div class="flex-1">
                <app-file-upload [form]="formStagione" [control]="'img_1'" [label]="'Immagine 1'" [multiple]="false" [accept]="'image/*'" [text]="'Seleziona un\'immagine'"></app-file-upload>
            </div>
            <div class="flex-1">
                <app-file-upload [form]="formStagione" [control]="'img_2'" [label]="'Immagine 2'" [multiple]="false" [accept]="'image/*'" [text]="'Seleziona un\'immagine'"></app-file-upload>
            </div>
            <div class="flex-1">
                <app-file-upload [form]="formStagione" [control]="'img_3'" [label]="'Immagine 3'" [multiple]="false" [accept]="'image/*'" [text]="'Seleziona un\'immagine'"></app-file-upload>
            </div>
        </div>

        <div class="ac-section-head mt-2">
            <h2>Programma</h2>
        </div>

        <app-file-upload [form]="formStagione" [control]="'programma'" [label]="'Programma stagione'" [multiple]="false" [accept]="'application/pdf'" [text]="'Seleziona il programma'"></app-file-upload>

        <div class="acc-actions">
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formStagione.valid || loading">Salva modifiche</button>
        </div>
    </form>
</section>

<app-loading-backoffice [visible]="loading"></app-loading-backoffice>
